import { Avatar } from '../../Avatar'

import * as styles from './UserAvatar.module.css'

function UserAvatar({
  avatar,
  avatarColor,
  className = styles.UserAvatar,
  fullname,
}) {
  return (
    <Avatar
      className={className}
      color={avatarColor}
      size={40}
      src={avatar}
      text={fullname}
    />
  )
}

export default UserAvatar
